import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import ClientsListing from './pages/Admin/ClientsListing';
import ClientDetail from './pages/Admin/ClientDetail';
import EnqueteursListing from './pages/Admin/EnqueteursListing';
import EnqueteurDetail from './pages/Admin/EnqueteurDetail';
import EnqueteurCreation from './pages/Admin/EnqueteurCreation';
import DossiersListing from './pages/Admin/DossiersListing';
import DossierDetail from './pages/Admin/DossierDetail';
import DossierCreation from './pages/Admin/DossierCreation';
import Statistics from './pages/Admin/Statistics';
import EnqueteurDashboard from './pages/Enqueteur/Dashboard';
import MesDossiers from './pages/Enqueteur/MesDossiers';
import EnqueteurDossier from './pages/Enqueteur/DossierDetail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Page de connexion */}
          <Route path="/" element={<Login />} />
          
          {/* Routes Administrateur */}
          <Route path="/admin" element={<Layout userType="admin" />}>
            <Route index element={<Navigate to="/admin/clients" replace />} />
            <Route path="clients" element={<ClientsListing />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="enqueteurs" element={<EnqueteursListing />} />
            <Route path="enqueteurs/nouveau" element={<EnqueteurCreation />} />
            <Route path="enqueteurs/:id" element={<EnqueteurDetail />} />
            <Route path="dossiers" element={<DossiersListing />} />
            <Route path="dossiers/nouveau" element={<DossierCreation />} />
            <Route path="dossiers/:id" element={<DossierDetail />} />
            <Route path="statistiques" element={<Statistics />} />
          </Route>
          
          {/* Routes Enquêteur */}
          <Route path="/enqueteur" element={<Layout userType="enqueteur" />}>
            <Route index element={<EnqueteurDashboard />} />
            <Route path="dossiers" element={<MesDossiers />} />
            <Route path="dossier/:id" element={<EnqueteurDossier />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
